module.exports = __webpack_public_path__ + "static/media/LogoMissions.736eac3c.svg";